<!-- Footer -->
<footer class="text-center text-lg-start bg-body-tertiary pepsico-footer pepsico-footer-evento legales-size">
  <section class="">
    <div class="container text-center text-md-start mt-5">
      <div class="row mt-3">
        <div class="col-md-4 col-lg-4 col-xl-4 mb-4 appfotter-pepsico">
          <h6 class="text-uppercase fw-bold">
            Descarga la App.
          </h6>
          <p class="fnt-footer-lex">
            Disfruta de los beneficios que tenemos para ti.
          </p>
          <div class="d-flex">
            <a href="https://www.apple.com/mx/app-store/" target="_blank" class="no-decoration">
              <img src="./assets/images/footer-logo-app1.png" class="store-app jump-shake">
            </a>
            <a href="https://play.google.com/store/games?hl=es_MX" target="_blank" class="no-decoration">
              <img src="./assets/images/footer-logo-app2.png" class="store-app jump-shake">
            </a>
          </div>
        </div>
        <div class="col-md-8 col-lg-8 col-xl-8 mb-4 appfotter-pepsico">
          <div class="square-footer-blue">
            <div class="container">
              <div class="row">
                <div class="col-sm-12 col-md-8 col-lg-8">
                  <h6 class="text-uppercase fw-bold mb-4">
                    ¿Podemos ayudarte?
                  </h6>
                  <p class="fnt-footer-lex">
                    Lunes a viernes de 8:30 a 18:30 hrs y Sábado de 9:00 a 14:00 hrs.
                  </p>
                  <div class="info-contact-footer">
                    <p class="fnt-footer-lex">
                      <svg-icon svgName="bi-whatsapp" [width]="30" [height]="30" />
                      Contáctanos vía <b class="pointer" (click)="openWhastApp()">WhatsApp</b>
                    </p>
                    @if((isAuthenticated$ | async) || authService.isLoggedIn()){
                    <p class="fnt-footer-lex">
                      <svg-icon svgName="bi-question-circle" [width]="30" [height]="30" />
                      Ir a <b class="pointer" routerLink="/help">Preguntas frecuentes</b>
                    </p>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Copyright -->
  <div class="text-center back-footer-foo">
    <a href="assets/pdf/aviso_de_privacidad_300326.pdf" download class="legales-2-footer">Aviso de privacidad</a> / <a href="assets/pdf/Bases_de_participación_CNV_300326.pdf" download class="legales-2-footer">Terminos y condiciones</a>
    / Concurso Nacional de Ventas® 2025. Todos los derechos reservados, Operado por Master Loyalty Group.
  </div>
  <!-- Copyright -->
</footer>